// PiP 우측 지도에 올리는 "정보 레이어" 선택 (순수 함수).
// 레이어 하나 = 지도 위에 보여줄 정보 한 종류(예: 예상 도착 지역). 일차에 따라 다른 정보를 보여줄 수 있도록
// 각 레이어가 지금 일차에 보여줄지(isActiveFor)를 스스로 판단한다. 새 정보는 레이어를 하나 만들어 mapLayerRegistry.js에 등록하면 된다.
//
// 레이어 정의: { id, title, isActiveFor(current) → boolean, View }
//   - current: 지금 { day, phase } (일차를 모르면 null)
//   - View: 지도와 설명을 그리는 React 컴포넌트. props로 { entries, current }를 받는다(entries: 24명의 조합 정보).

/** 지금 일차에 보여줄 수 있는 레이어(등록 순서). 하나도 없으면 빈 화면이 되지 않도록 전체를 돌려준다. */
export function activeLayers(layers, current) {
  const active = layers.filter((layer) => layer.isActiveFor(current));
  return active.length ? active : layers;
}

/** 지금 보여줄 레이어 한 개: 사용자가 고른 것이 지금 쓸 수 있으면 그것, 아니면 첫 번째로 쓸 수 있는 레이어. */
export function selectLayer(layers, current, selectedId) {
  const active = activeLayers(layers, current);
  return active.find((layer) => layer.id === selectedId) || active[0];
}
